'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _reactRouter2 = _interopRequireDefault(_reactRouter);

var _lodashCollectionFind = require('lodash/collection/find');

var _lodashCollectionFind2 = _interopRequireDefault(_lodashCollectionFind);

var _lodashCollectionFilter = require('lodash/collection/filter');

var _lodashCollectionFilter2 = _interopRequireDefault(_lodashCollectionFilter);

var _createRoutes = require('create-routes');

var _createRoutes2 = _interopRequireDefault(_createRoutes);

var _app = require('app');

var _app2 = _interopRequireDefault(_app);

function loadConfig(cb) {
  var stuff = require('config');
  if (module.hot) {
    module.hot.accept(stuff.id, function hotAccept() {
      return cb();
    });
  }
  return cb();
}

loadConfig(function loadConfigFunc() {
  return _app2['default'].loadContext(function loadContextFunc(pagesReq) {
    var router = undefined;
    var ref = require('config');
    var pages = ref.pages;
    var config = ref.config;
    var linkPrefix = config.linkPrefix;
    if (!__PREFIX_LINKS__ || !linkPrefix) {
      linkPrefix = '';
    }

    var routes = (0, _createRoutes2['default'])(pages, pagesReq);
    // Remove templates files.
    pages = (0, _lodashCollectionFilter2['default'])(pages, function (page) {
      return page.path !== null;
    });

    // Route already exists meaning we're hot-reloading.
    if (router) {
      router.replaceRoutes([_app2['default']]);
    } else {
      router = _reactRouter2['default'].run([routes], _reactRouter2['default'].HistoryLocation, function (Handler, state) {
        var page = undefined;
        page = (0, _lodashCollectionFind2['default'])(pages, function (p) {
          var path = linkPrefix + p.path;
          return path === state.path || path === state.pathname;
        });

        // Let app know the route is changing.
        if (_app2['default'].onRouteChange) {
          _app2['default'].onRouteChange(state, page, pages, config);
        }

        return _reactDom2['default'].render(_react2['default'].createElement(Handler, {
          config: config,
          pages: pages,
          page: page,
          state: state }), typeof window !== 'undefined' ? document.getElementById('react-mount') : void 0);
      });
    }
  });
});


/** WEBPACK FOOTER **
 ** ../~/gatsby/dist/utils/web-entry.js
 **/